module.exports = __webpack_public_path__ + "static/media/IMG_8064.7895910b.JPG";